import { InjectionToken, signal, WritableSignal } from '@angular/core';

export const IS_ORDER_UPDATING: InjectionToken<WritableSignal<boolean>> = new InjectionToken(
  'Состояние редактирования заказа',
  {
    factory: () => {
      return signal(false);
    },
  }
);
